import { refs, domReady } from '../modules/utils.js';

class CartBar extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    if (this.disconnected) return;

    await domReady();
    this.refs = refs(this);
    this.#listeners();

    this.parentElement.replaceWith(this);
  }

  disconnectedCallback() {
    this.disconnected = true;
  }

  #listeners() {

  }
}

customElements.define('cart-bar', CartBar);
